import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../../components/Shared/Spinner";
import PackageCard from "../../components/Dashboard/Courses/PackageCard";
import AddPackage from "../../components/Dashboard/Courses/AddPackage";
import { GetPackages } from "../../api/Packages/GetAllPackages";
import ThreeDotsIcon from "../../components/Icons/ThreeDotsIcon";
import PackageDropdown from "../../components/Dashboard/Packages/PackageDropdown";
import { useUserDataStore } from "../../stores/user";
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton";
const Packages = () => {
  const { userData } = useUserDataStore();
  const userRole = userData?.role || "";

  const [ShowAddPackage, setShowAddPackage] = useState(false);
  const { data: PackagesResponse, isLoading: isPackageLoading } = useQuery({
    queryFn: GetPackages,
    queryKey: ["packages"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const packages = PackagesResponse?.data?.pacakgeData || [];

  const handleAddPackageSuccess = () => {
    setShowAddPackage(false);
  };

  if (isPackageLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div>
      {ShowAddPackage ? (
        <div className="space-y-4">
          <DashboardInlineBackButton
            label="Back to packages"
            onClick={() => setShowAddPackage(false)}
          />
          <AddPackage onSuccess={handleAddPackageSuccess} />
        </div>
      ) : (
        <div>
          <div className="flex justify-between items-center py-7">
            <h1 className="text-burntBlack font-bold text-[32px]">
              Available Packages
            </h1>
            {userRole === "admin" && (
              <Button
                onClick={() => setShowAddPackage(true)}
                className="!h-12 w-48 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                variant="primary"
              >
                <AddIcon className="mr-1.5" />
                Add New Package
              </Button>
            )}
          </div>
          <div className="grid grid-cols-2 place-content-between gap-4">
            {packages.map((Packages) => (
              <div className="relative">
                <PackageCard packages={Packages} />
                <div className="absolute bottom-4 right-4 z-10">
                  <PackageDropdown role={userRole} packageId={Packages.id}>
                    <ThreeDotsIcon />
                  </PackageDropdown>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Packages;
